<template>
  <a-tooltip v-if="periods && periods.length">
    <template slot="title">
      <div class="giro-tooltip">
        <div class="giro-tooltip-header">
          <span>Giro Ponderado</span>
          <strong>{{ formatGiro(value, 2) }}</strong>
        </div>

        <div v-if="tendencyLabel">Tendência de Venda: {{ tendencyLabel }}</div>

        <div class="giro-tooltip-divider" />

        <table class="giro-tooltip-table">
          <thead>
            <tr>
              <th>Período</th>
              <th>Giro</th>
              <th>Qtd</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="period in periods" :key="period.label">
              <td>{{ period.label }}</td>
              <td>{{ formatGiro(period.giro, 2) }}</td>
              <td>{{ formatQuantity(period.quantity) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <div class="giro-cell">
      <span>
        {{ formatGiro(value, 1) }}
        <span class="u">un/dia</span>
      </span>

      <svg :width="svgWidth" :height="svgHeight">
        <polyline
          fill="none"
          :stroke="strokeColor"
          stroke-width="1.8"
          :points="points"
        />
      </svg>
    </div>
  </a-tooltip>

  <span v-else>
    {{ formatGiro(value, 1) }}
    <span class="u">un/dia</span>
  </span>
</template>

<script>
const TENDENCY_COLORS = {
    SEM_VENDA: '#bfbfbf',
    CRESCIMENTO_ACELERADO: '#52c41a',
    CRESCIMENTO: '#1890ff',
    ESTAVEL: '#1890ff',
    QUEDA: '#faad14',
    QUEDA_ACELERADA: '#ff4d4f',
};

const TENDENCY_LABELS = {
    SEM_VENDA: 'Sem Venda',
    CRESCIMENTO_ACELERADO: 'Crescimento Acelerado',
    CRESCIMENTO: 'Crescimento',
    ESTAVEL: 'Estável',
    QUEDA: 'Queda',
    QUEDA_ACELERADA: 'Queda Acelerada',
};

export default {
    name: 'QvGiroSparkline',

    props: {
        value: {
            type: Number,
            default: 0,
        },

        periods: {
            type: Array,
            default: null,
        },

        tendency: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            svgWidth: 30,
            svgHeight: 18,
            svgPadding: 2,
        };
    },

    computed: {
        strokeColor() {
            return TENDENCY_COLORS[this.tendency] || '#1890ff';
        },

        tendencyLabel() {
            return TENDENCY_LABELS[this.tendency] || '';
        },

        points() {
            const values = this.periods.map(period => Number(period.giro || 0));
            const min = Math.min(...values);
            const max = Math.max(...values);
            const range = max - min || 1;
            const innerWidth = this.svgWidth - this.svgPadding * 2;
            const innerHeight = this.svgHeight - this.svgPadding * 2;

            return values
                .map((value, index) => {
                    const x = this.svgPadding + (index * innerWidth) / (values.length - 1);
                    const y = this.svgHeight - this.svgPadding - ((value - min) / range) * innerHeight;

                    return `${x},${y}`;
                })
                .join(' ');
        },
    },

    methods: {
        formatGiro(value, digits) {
            return Number(value || 0).toFixed(digits).replace('.', ',');
        },

        formatQuantity(value) {
            return Number(value || 0).toLocaleString('pt-BR', {
                maximumFractionDigits: 2,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.giro-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: help;
}

.u {
  font-size: 10px;
  color: var(--text-3);
}

.giro-tooltip {
  min-width: 160px;
}

.giro-tooltip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  margin-bottom: 6px;
}

.giro-tooltip-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 6px 0;
}

.giro-tooltip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  color: #fff;
}

.giro-tooltip-table th {
  font-weight: 600;
  border-bottom: none;
  padding: 0 0 4px !important;
}

.giro-tooltip-table td {
  padding: 2px 0;
}

.giro-tooltip-table th + th,
.giro-tooltip-table td + td {
  text-align: right;
  padding-left: 12px !important;
}
</style>
